import { X } from "@phosphor-icons/react";
import { DialogTitle } from "@libs/zapi-ui/shadcn";
import { FigmaTypography } from "@libs/zapi-ui/custom";
import { ProjectIcon } from "@/zapi-frontend/shared/ui/ProjectIconEditor/ProjectIconEditor";
import { useTranslation } from "react-i18next";

type TProps = {
  projectName?: string;
  projectLogoUrl?: string | null;
  projectIconShape?: string | null;
  projectIconColor?: string | null;
  subtitle: string;
  onClose: () => void;
};

export function VersionModalHeader({
  projectName,
  projectLogoUrl,
  projectIconShape,
  projectIconColor,
  subtitle,
  onClose
}: TProps) {
  const { t } = useTranslation("common");
  return (
    <div className="flex h-[92px] shrink-0 items-center gap-5 p-5">
      <div className="flex min-w-0 flex-1 items-center gap-4">
        <ProjectIcon
          shape={projectIconShape}
          color={projectIconColor}
          logoUrl={projectLogoUrl}
          className="size-[52px]"
        />
        <span className="flex min-w-0 flex-1 flex-col">
          <DialogTitle asChild>
            <FigmaTypography component="span" variant="heading-3" color="zinc900" className="truncate leading-6">
              {projectName ?? t("versions.untitledProject")}
            </FigmaTypography>
          </DialogTitle>
          <FigmaTypography component="span" variant="body-2" color="zinc500">
            {subtitle}
          </FigmaTypography>
        </span>
      </div>
      <button
        type="button"
        aria-label={t("versions.close")}
        onClick={onClose}
        data-testid="version-modal-close-button"
        className="flex size-5 shrink-0 items-center justify-center text-innoveraZinc-500 hover:text-innoveraZinc-900"
      >
        <X size={20} />
      </button>
    </div>
  );
}
